var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex diy-button-group"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"button-item text-12px px-4px py-5px cursor-pointer min-w-32px text-center",class:{
      active: _vm.value === item,
      '!text-14px': _vm.textSize,
    },on:{"click":function($event){return _vm.buttonClick(item)}}},[_c('span',{staticClass:"bg-clip-text"},[_vm._v(_vm._s(item))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }